<template>
	<div class='b2b-modal__content'>
		<div class='b2b-modal__header'>
			<h5 class='modal-title b2b-modal__title'>
				{{ $Bitrix.Loc.getMessage('MODAL_SESSION_EXPIRED_TITLE') }}
			</h5>
		</div>

		<div class='b2b-modal__body'>
			<p class='b2b-modal__text'>
				{{ $Bitrix.Loc.getMessage('MODAL_SESSION_EXPIRED_TEXT') }}
			</p>
			<div class='b2b-modal__body-footer'>
				<button
					class='b2b-btn b2b-btn--full b2b-btn--big b2b-btn--blue'
					type='button'
					@click='refresh'
				>
					{{ $Bitrix.Loc.getMessage('MODAL_SESSION_EXPIRED_BTN') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:    'ModalSessionExpired',
	data: () => ({
		window: (window !== window.parent ? window.parent : window)
	}),
	methods: {
		refresh() {
			this.window.location.reload();
		}
	}
};
</script>
